export enum GamificationActivityType {
  COMPLETE_PRIVATE_CLASS = 'COMPLETE_PRIVATE_CLASS',

  COMPLETE_GROUP_CLASS = 'COMPLETE_GROUP_CLASS',

  COMPLETE_LESSON = 'COMPLETE_LESSON',

  COMPLETE_UNIT = 'COMPLETE_UNIT',

  COMPLETE_PRACTICE = 'COMPLETE_PRACTICE',

  COMPLETE_PRACTICE_PRONUNCIATION = 'COMPLETE_PRACTICE_PRONUNCIATION',

  COMPLETE_PRACTICE_COMMON_EXPRESSION = 'COMPLETE_PRACTICE_COMMON_EXPRESSION',

  COMPLETE_PRACTICE_NEWS = 'COMPLETE_PRACTICE_NEWS',

  COMPLETE_PRACTICE_VIDEO = 'COMPLETE_PRACTICE_VIDEO',

  COMPLETE_PRACTICE_INDUSTRY = 'COMPLETE_PRACTICE_INDUSTRY',

  COMPLETE_LEVEL = 'COMPLETE_LEVEL',

  COMPLETE_WEEKLY_CHALLENGE = 'COMPLETE_WEEKLY_CHALLENGE',

  COMPLETE_SPECIAL_DATE = 'COMPLETE_SPECIAL_DATE',

  COMPLETE_ACCESS = 'COMPLETE_ACCESS',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/gamification-activity-type.ts